// src/api/axios.js
import axios from 'axios';

const tokenStorage = {
  accessToken: null,
  refreshToken: null
};

const tokenManager = {
  setTokens: (accessToken, refreshToken) => {
    tokenStorage.accessToken = accessToken;
    tokenStorage.refreshToken = refreshToken;
  },

  getAccessToken: () => tokenStorage.accessToken,

  getRefreshToken: () => tokenStorage.refreshToken,

  clearTokens: () => {
    tokenStorage.accessToken = null;
    tokenStorage.refreshToken = null;
  }
};

export const BASE_URL = import.meta.env.VITE_APP_VSC_BE_API_URL;
const API_KEY = import.meta.env.VITE_APP_API_KEY;

const fetchJWT = async () => {
  return await axios
    .post(BASE_URL + '/v1/rest/common/auth/020/jwt', {
      apiKey: API_KEY
    })
    .then((res) => {
      tokenManager.setTokens(res.data.data.jwt, res.data.data.jwtForLongtime);
      return res.data.data.jwt;
    })
    .catch((err) => {
      throw err;
    });
};

export const authAxios = axios.create({
  baseURL: BASE_URL
});

authAxios.interceptors.request.use(
  async (config) => {
    let token = tokenManager.getAccessToken();

    if (!token) {
      try {
        token = await fetchJWT();
      } catch (err) {
        console.error('Failed to get JWT:', err);
        return Promise.reject(err);
      }
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

authAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await fetchJWT();
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return authAxios(originalRequest);
      } catch (refreshError) {
        tokenManager.clearTokens();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
